import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { UpdatePhoneHeader } from '../customer/header';
import { Caution } from './updatePhone/steps';
import { getUserDataByToken } from '../api';
import { FullPageLoader } from '../../component/helper';

/**
 * UpdateInfo component manages the entry point for updating user phone/email information.
 * Handles token validation, user data fetch, error/loading states, and navigation to update steps.
 */
export const UpdateInfo = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [userData, setUserData] = useState(null);

    useEffect(() => {
        const fetchUserData = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await getUserDataByToken({ token });
                if (response.code === 1) {
                    setUserData(response.data);
                } else {
                    setError(response.message || 'Failed to fetch user data.');
                }
            } catch (error) {
                setError('Error fetching user data.');
            } finally {
                setLoading(false);
            }
        };

        if (token) {
            fetchUserData();
        } else {
            setLoading(false);
        }
    }, [token]);

    if (!token) {
        return (
            <div className="d-flex bg-secondary w-100  justify-content-center align-items-center">

                <div className="bg-white d-flex flex-column gap-2 mw-425px  vh-100">
                    <UpdatePhoneHeader />
                    <Caution
                        icon="bi bi-exclamation-triangle-fill text-danger fs-4x"
                        text="Invalid or missing token. Please check your link or contact support."
                    />
                </div>
            </div>
        );
    }

    // if (loading) {
    //     return (
    //         <div className="d-flex  justify-content-center align-items-center">

    //             <div className="bg-white d-flex flex-column gap-2 mw-425px  vh-100">
    //                 <UpdatePhoneHeader />
    //                 <div className="d-flex flex-column align-items-center justify-content-center py-8">
    //                     <div className="spinner-border text-primary mb-4" role="status">
    //                         <span className="visually-hidden">Loading...</span>
    //                     </div>
    //                     <div className="fw-semibold fs-5">Loading your information...</div>
    //                 </div>
    //             </div>
    //         </div>
    //     );
    // }

    if (error) {
        return (
            <div className="d-flex  justify-content-center align-items-center">
                <div className="bg-white d-flex flex-column gap-2 mw-425px  vh-100">
                    <UpdatePhoneHeader />
                    <Caution
                        icon="bi bi-exclamation-triangle-fill text-danger fs-4x"
                        text={error}
                    />
                </div>
            </div>
        );
    }


    return (
        <div className="d-flex  justify-content-center align-items-center" >

            <div className="bg-white d-flex flex-column gap-2 mw-425px  vh-100">
                <UpdatePhoneHeader />
                {loading &&
                    <FullPageLoader></FullPageLoader>
                }
                <div className="px-4">
                    <Caution
                        icon="bi bi-exclamation-triangle-fill text-danger fs-4x"
                        text={
                            <>
                                Updating your  information will replace your existing contact information.
                                Make sure the new information is correct and accessible to receive verification codes.
                            </>
                        }
                    />
                    <div className="text-center fw-semibold fs-6 mb-8 mt-3 border p-6 rounded bg-light-dark">
                        Select the Information You Want to Update:
                    </div>
                    <div className="d-flex justify-content-between gap-4">
                        <button
                            type="button"
                            className="btn btn-primary fw-semibold d-flex flex-column align-items-center justify-content-center gap-2 px-4 py-3 rounded w-50"
                            onClick={() =>
                                navigate('/customer/update_phone_email/phone', {
                                    state: { token, userData }
                                })
                            }
                            aria-label="Update Phone"
                        >
                            <i className="bi bi-telephone-fill fs-3" aria-hidden="true"></i>
                            <div className="d-inline-flex align-items-center gap-1">
                                <span>Update Phone</span>
                                <i className="bi bi-chevron-right fs-5" aria-hidden="true"></i>
                            </div>
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary fw-semibold d-flex flex-column align-items-center justify-content-center gap-2 px-4 py-3 rounded w-50"
                            onClick={() =>
                                navigate('/customer/update_phone_email/email', {
                                    state: { token, userData }
                                })
                            }
                            aria-label="Update Email"
                            disabled
                        >
                            <i className="bi bi-envelope-fill fs-3" aria-hidden="true"></i>
                            <div className="d-inline-flex align-items-center gap-1">
                                <span>Update Email</span>
                                <i className="bi bi-chevron-right fs-5" aria-hidden="true"></i>
                            </div>
                        </button>
                    </div>
                </div>

            </div>
        </div>
    );
};